import { clientsApi } from '../utils/api';
import useRemoteOptions from './useRemoteOptions';

export const toClientOption = (client) => ({
  value: Number(client.id),
  label: client.name || client.company_name || `مشتری #${client.id}`,
  mobile: client.mobile,
  email: client.email,
  company_name: client.company_name,
  raw: client,
});

/** مشتریان از clients/options (جستجو + صفحه‌بندی سمت سرور) */
export default function useRemoteClientOptions({ selectedValue, pageSize, includeInactive = false } = {}) {
  return useRemoteOptions({
    fetcher: clientsApi.getOptions,
    toOption: toClientOption,
    selectedValue,
    pageSize,
    extraParams: includeInactive ? { include_inactive: true } : undefined,
  });
}
